<script lang="ts">
    
    import { Icon, Table } from "sveltestrap";
    import type { QuestionOptionsObject } from "../global";
    import Editable from "./FormPreview/Editable.svelte";
    import Watch from "./Watch.svelte";

    export let options: QuestionOptionsObject;

</script>

<Table>
    <thead>
        <tr>
            <th>Opción</th>
            <th>Invalida</th>
            <th>Muestra subsección</th>
            <th>N/A</th>
        </tr>
    </thead>
    <tbody>
        <Watch store={options.questionOptions} let:value={options}>
            {#each options as option}
                <tr>
                    <td>
                        <Editable store={option.text} />
                    </td>
                    <td>
                        <Watch store={option.restrict} let:value>
                            {#if value}
                                <Icon class="fs-4" name="check" />
                            {/if}
                        </Watch>
                    </td>
                    <td>
                        <Watch store={option.unLock} let:value>
                            {#if value}
                                <Icon class="fs-4" name="check" />
                            {/if}
                        </Watch>
                    </td>
                    <td>
                        <Watch store={option.isNA} let:value>
                            {#if value}
                                <Icon class="fs-4" name="check" />
                            {/if}
                        </Watch>
                    </td>
                </tr>
            {/each}
        </Watch>
    </tbody>
</Table>
